<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ transactionsQty }} {{ $t("transactions.transactions") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <span class="title-actions" :style="c1 ? 'margin-top: 1rem;' : ''">
      <button class="button" @click="$emit('get-transactions')">
        <b-icon icon="sync-alt"></b-icon>
      </button>

      <span
        v-if="permissions.downloadTransactionsReport"
        class="report-selector"
      >
        <button
          class="button"
          @click="$emit('download-transactions-report', reportModel)"
        >
          <b-icon icon="save"></b-icon>
        </button>

        <b-select v-model="reportModel">
          <option value="transactions">
            {{ $t("transactions.reportWithoutItems") }}
          </option>
          <option value="transactions-with-items">
            {{ $t("transactions.reportWithItems") }}
          </option>
        </b-select>
      </span>
    </span>

    <br v-show="c2" />

    <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>
    <span
      :style="
        c1
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block;"
        :placeholder="$t('transactions.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('transactions.store')"
        class="inline"
        v-model="store"
        @input="$emit('update-store', store)"
      >
        <option value="">{{ $t("transactions.allStores") }}</option>
        <option
          v-for="s in orderedStores"
          :key="s._id"
          :value="`${s._id}|${s.storeInfo.name}`"
        >
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["transactionsQty", "storeId", "storeName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: [],
      store: undefined,
      reportModel: "transactions"
    };
  },

  computed: {
    ...mapGetters(["stores", "preferences", "permissions"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    },

    orderedStores() {
      let orderedStores = [];
      if (this.preferences.storesOrder === "alphabetical") {
        orderedStores = [...this.stores].sort((a, b) => {
          return a.storeInfo.name.localeCompare(b.storeInfo.name);
        });
      } else {
        orderedStores = this.stores;
      }
      return orderedStores;
    }
  },

  mounted() {
    this.store =
      this.storeId && this.storeName ? `${this.storeId}|${this.storeName}` : "";
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
.title-actions,
.report-selector {
  display: inline-flex;
  align-items: center;
}
.title-actions {
  gap: 0.25rem;
  vertical-align: top;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
